
import { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import editresultapi from '../api/editresult';
import loginapi from '../api/login';
import SemesterResult from '../components/editResult/SemesterResult';
import AddACourse from '../components/editResult/AddNewFormFillupCourse';
import { APISERVERURL } from '../APIServerURL';
import { AiOutlineDownload } from "react-icons/ai";

function EditResult({accessToken,setAccessToken,setRefreshFailed}) {
  const navigate = useNavigate();
  const [isAppLoaded,setIsAppLoaded]=useState(false);
  const [sessionSemesters,setSessionSemesters]=useState([]);
  const [allSessions,setAllSessions]=useState([]);
  const [sessionsLoaded,setSessionsLoaded]=useState(false);
  const [rollno,setRollno]=useState('');
  const [currentStudent,setCurrentStudent]=useState(null);
  const [showStudentNotFound,setShowStudentNotFound]=useState(false);
  const [showAddStudent,setShowAddStudent]=useState(false);

  const semesters=[1,2,3,4,5,6,7,8];
  const courseTypes=['core','elective'];

   const handleStudentDetailsChange = (e) => {
      const { name, value } = e.target;
      const updatedStudent={...currentStudent,[name]: value };
      setCurrentStudent(updatedStudent);
  };
  
    const handleSaveStudentDetails = async (e) => {
      e.preventDefault();
      try{       
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await editresultapi.post('/updateStudentProgrammeDetails',currentStudent,{headers:{'Authorization':`Bearer ${accessToken}`}});            
           }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="admin")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await editresultapi.post('/updateStudentProgrammeDetails',currentStudent,{headers:{'Authorization':`Bearer ${nat}`}});   

       
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              //setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
    };
    
  

  const fetchAllSessions=async ()=>{
    setSessionsLoaded(false);
    try{       
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await editresultapi.post('/fetchAllSessions',{},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      setAllSessions(response.data.allSessions);
      //alert(JSON.stringify(response.data.allSessions));
      }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          
          setAccessToken(nat);
          setRefreshFailed(false);  
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await editresultapi.post('/fetchAllSessions',{},{headers:{'Authorization':`Bearer ${nat}`}});  
                      setAllSessions(response.data.allSessions);
                  }
                  catch(err)
                  {
                    if( err.response.status===403)
                      {
                        navigate(`/accessdenied`); 
                      }
                    alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            alert("error: "+JSON.stringify(err));
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
            setSessionsLoaded(true);
          }
  }

  const fetchSessionSemesters=async ()=>{
    try{       
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await editresultapi.post('/getSessionSemestersOfAStudent',{rollno},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      setCurrentStudent(response.data.studentDetails);
      setShowStudentNotFound(true);
      setSessionSemesters(response.data.sessionSemester||[]);
      }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          
          setAccessToken(nat);
          setRefreshFailed(false);  
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await editresultapi.post('/getSessionSemestersOfAStudent',{rollno},{headers:{'Authorization':`Bearer ${nat}`}});                         
                      setCurrentStudent(response.data.studentDetails);
                      setShowStudentNotFound(true);
                      setSessionSemesters(response.data.sessionSemester||[]);
                  }
                  catch(err)
                  {
                    if( err.response.status===403)
                      {
                        navigate(`/accessdenied`); 
                      }
                    alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            alert("error: "+JSON.stringify(err));
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
          }
  }

  function downloadFile(fname)
    {
      fetch(`${APISERVERURL}/pdf/${fname}`).then((response) => {
        response.blob().then((blob) => {         
            // Creating new object of PDF file
            const fileURL =
                window.URL.createObjectURL(blob);
                 
            // Setting various property values
            let alink = document.createElement("a");
            alink.href = fileURL;
            alink.download = fname;
            alink.click();
            setIsAppLoaded(true);
        });
      });
    }
 const getGradeCardsOfAStudent=async (e,bg)=>{
    e.preventDefault();
    try{
      //alert(img+" "+postId);
      //post request to deletePhoto wit {id,fileName}
      setIsAppLoaded(false);
      const response= await editresultapi.post('/getGradeCardsOfAStudent',{rollno:currentStudent.rollno,bg},{headers:{'Authorization':`Bearer ${accessToken}`}});    
      alert(response.data);
      downloadFile(response.data);
    }
    catch(err)
    {
      if( err.response.status===403)
        {
          navigate(`/accessdenied`); 
        }
      try{
        const config = { withCredentials: true };
        const x=await loginapi.get('/getAccessToken',config);
        //alert(JSON.stringify(x['data']['accessToken']));
        
        const nat=x['data']['accessToken'];
        setAccessToken(nat);
        //console.log(`ne at ${nat}`);
        //console.log(`Second at:${accessToken}`);
        //alert('ok');
        try{       
          const response= await editresultapi.post('/getGradeCardsOfAStudent',{rollno:currentStudent.rollno,bg},{headers:{'Authorization':`Bearer ${nat}`}});    
          alert(JSON.stringify(response.data));
          downloadFile(response.data);
         }
         catch(err)
         {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          alert('unusual error newposts.js');
          setIsAppLoaded(true);
          //alert(JSON.stringify(err));
          //navigate('/');
         }
      }
      catch(err)
      {
        alert(JSON.stringify(err));
        setIsAppLoaded(true);
        //setError(JSON.stringify(err));
        //navigate('/');
      }
 
    }
 }
 
  useEffect(()=>{   
    fetchAllSessions();
    },[]);

    const handleRollnoChange=(e)=>{
      const {  value } = e.target;
      setShowStudentNotFound(false);
        setRollno(value);
    }
    const handleSearch=async (e)=>{
      e.preventDefault();
      setSessionSemesters([]);
      await fetchSessionSemesters();
    }
    const handleAddCourse=(e)=>{
      e.preventDefault();
      setShowAddStudent((prev) => !prev); // Toggle between true and false
    }
    
    const reloadDetails=async ()=>{
      setSessionSemesters([]);
      await fetchSessionSemesters();
    }
    
    return (
      <main className="flex flex-col items-center">
  <div className="w-[98%] max-w-[1200px]">
    <div className="text-center">
      <h1 className="text-2xl text-gray-400 text-center">
        EDIT RESULT OF A STUDENT
      </h1>
    </div>

        <div className="w-full flex items-center justify-center mt-4">
                <div
                  className="text-center w-full max-w-[600px]  grid grid-cols-[1fr_3fr_1fr] gap-2 p-1 text-sm align-items-end "
                >
                <label className="px-2 py-2">ROLLNO:</label>

                <input
                                type="text" 
                                name="txtRollno"
                                value={rollno}
                                onChange={handleRollnoChange}
                              className="w-full p-2 mt-1 bg-transparent border-b border-gray-400 focus:border-green-500 focus:border-b outline-none transition-all"
                              />
              <button className="bg-green-500 text-white font-semibold px-6 py-2 rounded-full shadow-md transition-all duration-300 hover:bg-green-600 hover:scale-105 active:scale-95"
              onClick={handleSearch}>
                SEARCH
              </button>

                </div>
        </div>

    {currentStudent&&(<div className="w-full mt-2 flex flex-col items-center ">
      {
        <div className="w-full bg-gray-200 border-t border-red-900 flex justify-between items-center p-2 text-xs">                
                <input
                    type="text"
                    autoComplete="off"
                    name="name"
                    value={currentStudent.name}
                    onChange={handleStudentDetailsChange}
                    onBlur={handleSaveStudentDetails}
                    className="w-full max-w-[500px] border-b border-gray-400 focus:border-blue-600 focus:text-blue-600 focus:outline-none p-2 mt-1 bg-transparent"
                  />

                    <button 
                      onClick={(e) => getGradeCardsOfAStudent(e,'yes')} 
                      className="flex items-center gap-2 bg-orange-600 text-white px-4 py-2 rounded-lg hover:bg-orange-700 transition duration-200"
                    >
                      <AiOutlineDownload size={20} />
                      Bg GradeCard 
                    </button>
                    <button 
                      onClick={(e) => getGradeCardsOfAStudent(e,'no')} 
                      className="flex items-center gap-2 bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-700 transition duration-200"
                    >
                      <AiOutlineDownload size={20} />
                      Bare GradeCard
                    </button>

                <button class="bg-blue-600 text-white text-xs flex items-center gap-2 px-2 py-2 rounded-lg transition-transform duration-200 hover:bg-blue-700 hover:scale-105 active:scale-95"
                onClick={handleAddCourse}>
                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4"/>
                </svg>
                ADD COURSE
              </button>
        </div>
      } 
      {
        <div
        className="bg-gray-200 text-center w-full max-w-full  grid grid-cols-[1fr_1fr_1fr] lg:gap-1 md:p-1 text-sm"
         >
            <div className="w-full flex px-2">
                    <div className="w-full flex flex-col">      
                      <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">Programme Name</label>
                         <input
                          type="text" autoComplete="off"
                          name="programme_name"
                          value={currentStudent.programme_name}
                          onChange={handleStudentDetailsChange}   
                          onBlur={handleSaveStudentDetails}                       
                          className="w-full border rounded p-2 mt-1"
                        />
                    </div>
            </div> 
            <div className="w-full flex px-2">
                    <div className="w-full flex flex-col">      
                      <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">Honours Name</label>
                         <input
                          type="text" autoComplete="off"
                          name="honours_name"
                          value={currentStudent.honours_name}
                          onChange={handleStudentDetailsChange}
                          onBlur={handleSaveStudentDetails}
                          className="w-full border rounded p-2 mt-1"
                        />
                    </div>
            </div>
            <div className="w-full flex px-2">
                    <div className="w-full flex flex-col">      
                      <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">Degree Awarded</label>
                         <input
                          type="text" autoComplete="off"
                          name="degree_awarded"
                          value={currentStudent.degree_awarded}
                          onChange={handleStudentDetailsChange}
                          onBlur={handleSaveStudentDetails}
                          className="w-full border rounded p-2 mt-1"
                        />
                    </div>
            </div>


            {/*<div className="w-full flex px-2">
                    <div className="w-full flex flex-col">      
                      <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">IssueDt.</label>
                      <input
                          type="date"
                          name="gradecard_issue_date"
                          value={currentStudent.gradecard_issue_date}
                          onChange={handleStudentDetailsChange}
                          onBlur={handleSaveStudentDetails}
                          className="w-full border rounded p-2 mt-1"
                           />
                    </div>
            </div> */}

            </div>
      }
      <div
        className={`w-full  flex flex-col items-center mb-1 bg-yellow-100 transition-[max-height,opacity,transform] duration-500 ease-in-out overflow-hidden 
          ${ showAddStudent ? "max-h-[500px] opacity-100 scale-100" : "max-h-0 opacity-0 scale-100" }`}
        >
          {sessionsLoaded && <div className="w-full max-w-[600px] p-2">
            <AddACourse 
            accessToken={accessToken}
            setAccessToken={setAccessToken}
            setRefreshFailed={setRefreshFailed}
            rollno={currentStudent.rollno} 
            sessions={allSessions}
            semesters={semesters}
            courseTypes={courseTypes}
            reloadDetails={reloadDetails}
            ></AddACourse>
          </div>
          }
          {!sessionsLoaded && <div>Please wait...</div>}
      </div>
      

        {/* Render SemesterResult for each sessionSemester */}
        {sessionSemesters && sessionSemesters.length>0 && sessionSemesters.map((sessionSemester, index) => (
          <SemesterResult
            key={index} // Ensure unique keys for React list rendering
            accessToken={accessToken}
            setAccessToken={setAccessToken}
            setRefreshFailed={setRefreshFailed}
            rollno={rollno} // Use rollno from state (if static) or from sessionSemester
            session={sessionSemester.session}
            semester={sessionSemester.semester}
          />
        ))}
        {!sessionSemesters || sessionSemesters.length===0 && <p>NO RESULT TO DISPLAY</p>}
    </div>)}
    {showStudentNotFound && !currentStudent && <div>STUDENT NOT FOUND!</div>}
  </div>
</main>

    )
  }
  
  export default EditResult